import { parsedTakeaways } from '@features/lci-report/domain/key-takeaways';
import { TextProps, TextPropsOptions } from '@features/powerpoint';
import { NEWLINE_REGEX } from '../../domain/key-takeaways';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export const formatKeyTakeawaysText = (
  keyTakeaways: string,
  headerTextOptions?: TextPropsOptions,
  bulletTextOptions?: TextPropsOptions
): TextProps[] => {
  return [
    {
      text: keyTakeaways ? 'KEY TAKEAWAYS' : '',
      options: {
        color: unifiedPlatformColorPalette.inmarketGreen,
        fontSize: 16,
        bold: true,
        h: 0.4,
        w: 2.55,
        x: 8.25,
        y: 1.95,
        ...headerTextOptions,
      },
    },
    {
      text: parsedTakeaways(keyTakeaways.split(NEWLINE_REGEX)),
      options: {
        h: 3.96,
        w: 5.22,
        x: 8.25,
        y: 2.48,
        valign: 'top',
        paraSpaceAfter: 12,
        fontSize: 14,
        ...bulletTextOptions,
      },
    },
  ];
};
